import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function RoulettePage() {
  const navigate = useNavigate();
  const canvasRef = useRef(null);

  const [participants, setParticipants] = useState([
    { id: 1, name: "" },
    { id: 2, name: "" }
  ]);

  const [isSpinning, setIsSpinning] = useState(false);
  const [result, setResult] = useState(null);
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [alertMsg, setAlertMsg] = useState('');

  const drawRoulette = (angle = 0) => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    const width = canvas.width;
    const height = canvas.height;
    const centerX = width / 2;
    const centerY = height / 2;
    const radius = 180;

    const activeParticipants = participants.filter(p => p.name.trim() !== "");
    const len = activeParticipants.length > 0 ? activeParticipants.length : 1;
    const arc = (2 * Math.PI) / len;

    ctx.clearRect(0, 0, width, height);

    if (activeParticipants.length === 0) {
      ctx.beginPath();
      ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI);
      ctx.strokeStyle = "#ddd";
      ctx.stroke();
      ctx.textAlign = "center";
      ctx.fillStyle = "#999";
      ctx.font = "16px Pretendard";
      ctx.fillText("항목을 입력해주세요", centerX, centerY);
    } else {
      activeParticipants.forEach((p, i) => {
        const currentAngle = angle + i * arc;
        ctx.beginPath();
        ctx.fillStyle = `hsl(${(i * 360) / len}, 70%, 75%)`;
        ctx.moveTo(centerX, centerY);
        ctx.arc(centerX, centerY, radius, currentAngle, currentAngle + arc);
        ctx.fill();
        ctx.strokeStyle = "#fff";
        ctx.lineWidth = 2;
        ctx.stroke();

        ctx.save();
        ctx.translate(centerX, centerY);
        ctx.rotate(currentAngle + arc / 2);
        ctx.textAlign = "right";
        ctx.fillStyle = "#333";
        ctx.font = "bold 16px Pretendard";
        ctx.fillText(p.name, radius - 20, 10);
        ctx.restore();
      });
    }

    ctx.fillStyle = "#FF5A5A";
    ctx.beginPath();
    ctx.moveTo(centerX + radius + 5, centerY);
    ctx.lineTo(centerX + radius + 25, centerY - 15);
    ctx.lineTo(centerX + radius + 25, centerY + 15);
    ctx.fill();
  };

  useEffect(() => {
    drawRoulette();
  }, [participants]);

  const spin = () => {
    const activeOnes = participants.filter(p => p.name.trim() !== "");
    if (isSpinning || activeOnes.length < 2) {
      if (activeOnes.length < 2) {
        setAlertMsg("최소 2개 이상의 항목을 입력해주세요!");
        setShowAlertModal(true);
      }
      return;
    }

    setIsSpinning(true);
    setResult(null);

    const spinAngle = Math.random() * 360 + 1800;
    const duration = 4000;
    const start = performance.now();

    const animate = (time) => {
      const elapsed = time - start;
      const progress = Math.min(elapsed / duration, 1);
      const easeOut = 1 - Math.pow(1 - progress, 4);
      const angle = (spinAngle * easeOut * Math.PI) / 180;
      drawRoulette(angle);

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        setIsSpinning(false);
        const finalAngle = (spinAngle % 360);
        const arcDegree = 360 / activeOnes.length;
        const index = Math.floor((360 - finalAngle) / arcDegree) % activeOnes.length;
        setResult(activeOnes[index].name);
      }
    };
    requestAnimationFrame(animate);
  };

  const resetAll = () => {
    setParticipants([
      { id: 1, name: "" },
      { id: 2, name: "" }
    ]);
    setResult(null);
  };

  return (
    <div style={containerStyle}>
      <button onClick={() => navigate(-1)} style={backBtn}>← 이전으로</button>
      <h2 style={{textAlign: 'center', marginBottom: '40px', fontWeight: '800'}}>🎡 돌려돌려 돌림판</h2>

      <div style={layout}>
        <div style={inputSection}>
          <h3 style={{fontSize: '18px', fontWeight: '700', marginBottom: '15px'}}>항목 리스트</h3>
          {/* ✅ 6개 이상부터 스크롤 */}
          <div style={{
            maxHeight: participants.length >= 6 ? '300px' : 'none',
            overflowY: participants.length >= 6 ? 'auto' : 'visible',
            paddingRight: participants.length >= 6 ? '6px' : '0',
            marginBottom: '20px',
          }}>
            {participants.map((p, idx) => (
              <div key={p.id} style={{display: 'flex', gap: '8px', marginBottom: '10px'}}>
                <input
                  style={inputStyle}
                  placeholder={`예: 벌칙 항목 ${idx + 1}`}
                  value={p.name}
                  onChange={(e) => {
                    const updated = [...participants];
                    updated[idx].name = e.target.value;
                    setParticipants(updated);
                  }}
                />
                <button onClick={() => setParticipants(participants.filter(item => item.id !== p.id))} style={delBtn}>✕</button>
              </div>
            ))}
          </div>

          <div style={actionButtonGroup}>
            <button onClick={() => setParticipants([...participants, {id: Date.now(), name: ""}])} style={addBtn}>+ 항목 추가</button>
            <button onClick={resetAll} style={fullResetBtn}>♻️ 전체 초기화</button>
          </div>
        </div>

        <div style={canvasSection}>
          <div style={rouletteWrapper}>
            <canvas ref={canvasRef} width={400} height={400} style={{maxWidth: '100%'}} />
          </div>
          <button onClick={spin} disabled={isSpinning} style={spinBtn}>
            {isSpinning ? "운명에 맡기는 중..." : "START!"}
          </button>

          {result && (
            <div style={resultContainer}>
              <div style={sparkleWrapper}>✨ 축하합니다! ✨</div>
              <div style={resultTextWrapper}>
                <div style={resultText}>{result}</div>
              </div>
              <div style={resultSub}>당첨되었습니다!</div>
            </div>
          )}
        </div>
      </div>

      {showAlertModal && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <h3 style={modalTitleStyle}>{alertMsg}</h3>
            <div style={modalButtonContainerStyle}>
              <button style={modalConfirmButtonStyle} onClick={() => setShowAlertModal(false)}>확인</button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes popIn {
          0% { transform: scale(0.5); opacity: 0; }
          70% { transform: scale(1.1); }
          100% { transform: scale(1); opacity: 1; }
        }
        @keyframes rainbowText {
          0% { color: #4F46E5; }
          25% { color: #EC4899; }
          50% { color: #F59E0B; }
          75% { color: #10B981; }
          100% { color: #4F46E5; }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
      `}</style>
    </div>
  );
}

// ✅ 푸터 비율 고정
const containerStyle = {
  maxWidth: '1000px', margin: '0 auto', padding: '60px 20px 80px',
  minHeight: '100vh', boxSizing: 'border-box',
  fontFamily: 'Pretendard, sans-serif'
};

const backBtn = { padding: '10px 20px', background: '#fff', border: '1px solid #E2E8F0', borderRadius: '10px', cursor: 'pointer', marginBottom: '30px', fontWeight: '600' };
const layout = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '50px', alignItems: 'start' };
const inputSection = { background: '#fff', padding: '25px', borderRadius: '24px', border: '1px solid #E2E8F0', boxShadow: '0 4px 6px rgba(0,0,0,0.02)' };
const inputStyle = { flex: 1, padding: '14px', borderRadius: '12px', border: '1px solid #E2E8F0', fontSize: '15px', outline: 'none', transition: 'border-color 0.2s' };
const delBtn = { width: '45px', background: '#FFF1F1', border: 'none', borderRadius: '12px', color: '#FF5A5A', cursor: 'pointer', fontWeight: 'bold' };
const actionButtonGroup = { display: 'grid', gridTemplateColumns: '1.5fr 1fr', gap: '10px' };
const addBtn = { padding: '14px', background: '#4F46E5', color: '#fff', border: 'none', borderRadius: '12px', cursor: 'pointer', fontWeight: 'bold' };
const fullResetBtn = { padding: '14px', background: '#F8FAFC', border: '1px solid #E2E8F0', color: '#64748B', borderRadius: '12px', cursor: 'pointer', fontWeight: 'bold' };
const canvasSection = { display: 'flex', flexDirection: 'column', alignItems: 'center' };
const rouletteWrapper = { background: '#fff', padding: '10px', borderRadius: '50%', boxShadow: '0 20px 40px rgba(0,0,0,0.08)', position: 'relative' };
const spinBtn = { marginTop: '30px', padding: '18px 60px', background: '#000', color: '#fff', border: 'none', borderRadius: '50px', fontWeight: '900', fontSize: '20px', cursor: 'pointer', boxShadow: '0 10px 25px rgba(0,0,0,0.2)' };
const resultContainer = { marginTop: '40px', textAlign: 'center', animation: 'popIn 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275)', padding: '30px', background: 'linear-gradient(145deg, #ffffff, #f3f4f6)', borderRadius: '30px', boxShadow: '0 20px 50px rgba(79, 70, 229, 0.15)', border: '2px solid #EEF2FF' };
const sparkleWrapper = { fontSize: '20px', fontWeight: 'bold', color: '#F59E0B', marginBottom: '10px', animation: 'float 2s infinite ease-in-out' };
const resultTextWrapper = { padding: '10px 20px', borderBottom: '4px double #E0E7FF', marginBottom: '15px' };
const resultText = { fontSize: '48px', fontWeight: '900', animation: 'rainbowText 3s infinite linear', letterSpacing: '-1px' };
const resultSub = { fontSize: '18px', fontWeight: '700', color: '#6366F1' };
const modalOverlayStyle = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.4)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 };
const modalContentStyle = { backgroundColor: '#fff', padding: '30px 40px', borderRadius: '16px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)', textAlign: 'center', minWidth: '320px' };
const modalTitleStyle = { fontSize: '18px', fontWeight: '600', color: '#333', margin: '0 0 25px 0' };
const modalButtonContainerStyle = { display: 'flex', justifyContent: 'center', gap: '12px' };
const modalConfirmButtonStyle = { padding: '10px 20px', border: 'none', backgroundColor: '#4A90E2', color: '#fff', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '600', width: '100%' };

export default RoulettePage;